module.exports = __webpack_public_path__ + "static/media/icons.3a1f0d43.svg";